import React, { Component } from "react";
import Home from "./Home";
import { Grid } from "@material-ui/core";
import PublishIcon from "@material-ui/icons/Publish";
import HeaderCard from "../../components/HeaderCards";
import { connect } from "react-redux";
import {  Link } from "react-router-dom";
import { withRouter } from "../../utils/withRouter";
import { getVideoCount } from "../../Redux/Actions/videos";
import { getEmailConfigurations } from "../../Redux/Actions/email";
import { isEmailConfigured } from "../../Redux/Actions/auth";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Styles from "./styles";
import "./styles.css";
import Tooltip from "@material-ui/core/Tooltip";
type IProps = {
  history: any;
  videoCount: number;
  viewCount: number;
  emailConfig: any;
  user: any;
  auth: any;
  getEmailConfigurations: () => void;
  getVideoCount: () => void;
  isEmailConfigured: () => void;
};
class Dashboard extends Component<IProps> {
  state = {
    showDashboard: true,
    showVideos: false,
    emailNoteOpen: !this.props?.auth?.isEmailConfigured,
    emailConfigSttus: false,
  };
  componentDidMount() {
    this.props.getVideoCount();
    this.props.getEmailConfigurations();
  }

  emailConfigWarning = () => {
    if (localStorage.getItem("viideon_dismiss_email_config") === "true") {
      return null;
    }
    return (
      <Dialog
        open={!this.props.auth.isEmailConfigured}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "#fdb415" }} id="alert-dialog-title">
          {"Connect your email"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Connect your email in Configuration to personalize your reply-to
            address when sharing videos.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => this.props.history.push(`/configuration`)}
            variant="outlined"
            color="primary"
          >
            Configure
          </Button>
          <Button
            onClick={() => {
              localStorage.setItem("viideon_dismiss_email_config", "true");
              this.EmailConfigStatus();
            }}
            color="secondary"
            variant="outlined"
          >
            Don't show again
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  navigate = (show?: string) => {
    this.props.history.push({ pathname: "/video/create", show: show });
  };
  EmailConfigStatus = () => {
    this.props.isEmailConfigured();
    this.props.history.push("/");
  };
  render() {
    const { user } = this.props;
    const { loading, emailConfigurations } = this.props.emailConfig;

    return (
      <Home>
        <div className="wrapperDashboard">
          <div className="dashboardTop">
            <h3 className="dashboardTopLeft">
              Welcome, {user?.firstName || user?.lastName || user?.userName}!
            </h3>
          </div>
          <Grid container spacing={2} className="dashHeaderWrapper">
            <Grid item xs={6} md={3}>
              <Link to="/videos" className="link-style">
                <HeaderCard
                  styles={Styles.headerCardOne}
                  Number={this.props.videoCount ? this.props.videoCount : 0}
                  Title="VIDEOS"
                  iconBg="#368BC4"
                />
              </Link>
            </Grid>
            <Grid item xs={6} md={3}>
              <Tooltip title="Feature Coming Soon">
                <div onClick={() => alert("Feature not created yet")}>
                  <HeaderCard
                    styles={Styles.headerCardTwo}
                    Number={this.props.viewCount ? this.props.viewCount : 0}
                    Title="VIEWS"
                    iconBg="#3A966F"
                  />
                </div>
              </Tooltip>
            </Grid>
            <Grid item xs={6} md={3}>
              <Tooltip title="Feature Coming Soon">
                <div onClick={() => alert("Feature not created yet")}>
                  <HeaderCard
                    styles={Styles.headerCardFour}
                    Number={0}
                    Title="CONTACTS"
                    iconBg="#CC5551"
                  />
                </div>
              </Tooltip>
            </Grid>
          </Grid>
          <Grid container className="wrapperActivityHome">
            <Grid item xs={6} md={3}>
              <div
                className="actionsHomePage"
                onClick={() => this.navigate("upload")}
              >
                <PublishIcon style={iconStyle} />
                <h5 className="cursorPointer">
                  Record/Upload a Single Video Message
                </h5>
              </div>
            </Grid>
          </Grid>
        </div>
        {!loading &&
            emailConfigurations &&
            emailConfigurations.length < 1 &&
          this.emailConfigWarning()}
      </Home>
    );
  }
}

const iconStyle = {
  fontSize: "50px",
  cursor: "pointer",
  color: "#FFFFFF",
};
const mapStateToProps = (state: any) => {
  return {
    videoCount: state.video.videoCount,
    viewCount: state.video.viewCount,
    user: state.auth.user,
    auth: state.auth,
    emailConfig: state.email,
  };
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    getEmailConfigurations: () => dispatch(getEmailConfigurations()),
    getVideoCount: () => dispatch(getVideoCount()),
    isEmailConfigured: () => dispatch(isEmailConfigured()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Dashboard)
);
